import { gql } from "@apollo/client";

export const PROMO_DETAIL_FRAGMENT = gql`
  fragment PromoDetailFields on PromoDetailType {
    promoEventId
      promoName
      promoCode
      type {
        promoTypeId
        promoTypeName
        promoTypeCode
        promoTypeKey
      }
      status {
        promoStatusId
        promoStatusName
        promoStatusKey
      }
      purchaser {
        purchaserId
        purchaserKey
        purchaserName
      }
      retailer {
        retailerId
        retailerKey
        retailerName
      }
      fundingMethod
      startDate
      endDate
      amountTolerance
      dateTolerance
      notes
      financials {
        committedBudget
        previouslyClaimed
        remainingOpenBalance
      }
      lifecycle {
        createdAt
        createdByName
        activatedAt
        activatedByName
        completedAt
        cancelledAt
      }
      matchBreakdown {
        statusKey
        statusName
        count
      }
      productsInScopeCount
      matchedDeductionsCount
      appliedDeductionsCount
      isCurrentlyActive
      sourceDocument {
        id
        fileName
        fileSize
        fileMimeType
        fileDisplayName
        filePath
        createdAt
        updatedAt
      }
  }
`;

export const GET_PROMO_DETAIL = gql`
  ${PROMO_DETAIL_FRAGMENT}
  query GetPromoDetail($promoEventId: Int!) {
    getPromoDetail(promoEventId: $promoEventId) {
      ...PromoDetailFields
    }
  }
`;
